module.exports = __webpack_public_path__ + "img/prize1.f5ab3f78.png";